import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import BookingClosed from "./BookingClosed";
import usePublicAvailability from "../hooks/usePublicAvailability";

const BookingAvailabilityGate = ({ children }) => {
  const {
    bookingsEnabled,
    paymentsEnabled,
    updatedUtc,
    loading,
  } = usePublicAvailability();

  if (loading) {
    return null;
  }

  if (!bookingsEnabled || !paymentsEnabled) {
    return (
      <div className="booking-page">
        <Header />
        <BookingClosed
          bookingsEnabled={bookingsEnabled}
          paymentsEnabled={paymentsEnabled}
          updatedUtc={updatedUtc}
        />
        <Footer />
      </div>
    );
  }

  return children;
};

export default BookingAvailabilityGate;
